import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_PARTNER_USER_GET_LIST,
} from 'api/actionTypes';

export default async function getPartnerUserListByPartnerId({ state, apiClient }, { partnerId }) {
  typeCheck('partnerId::PositiveNumber', partnerId);
  const partnerUserListStatePath = ['partners', 'users', 'listByPartnerId', partnerId];

  if (state.get(partnerUserListStatePath)) {
    return state.get(partnerUserListStatePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_PARTNER_USER_GET_LIST,
    queryId: String(partnerId),
    state: state,
    payload: {
      partnerId,
    },
    onSuccess(partnerUserList) {
      state.set(partnerUserListStatePath, partnerUserList);
    },
  });
}
